import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {

        primary: '#114b5f',
        fondomenu: '#114b5f',
        fondobusqueda: '#fff',
        fondolista: '#fff',
        fondoheader: '#fff',
        fondoprincipal: '#e5ddd5',
        headeryfooter: '#005a84',
        fondoformulario: '#fff',
        //fondoformulario: '#FFFBE6',

      },
    },
  },
  lang: {
    locales: {
      es
    },
    current: 'es',
  },
});